// Test IDs for the home / landing feature.

export const HOME = {
        siteHeader: 'site-header',
        headerLogo: 'header-logo',
        headerContactBtn: 'header-whatsapp-btn',
        floatingContactBtn: 'floating-whatsapp-btn',
        heroSection: 'hero-section',
        heroImage: 'hero-image',
        heroJoinBtn: 'hero-whatsapp-btn',
        heroAboutBtn: 'hero-about-btn',
        narrativeSection: 'narrative-section',
        basedOnNote: 'based-on-note',
        aboutAnchor: 'de-que-se-trata',
        tiersSection: 'tiers-section',
        tierCard250: 'tier-card-250',
        tierWhatsApp250: 'tier-whatsapp-btn-250',
        tierCard1200: 'tier-card-1200',
        tierWhatsApp1200: 'tier-whatsapp-btn-1200',
        tierCard5000: 'tier-card-5000',
        tierWhatsApp5000: 'tier-whatsapp-btn-5000',
        bankInfoBtn: 'bank-info-btn',
        bankInfoDialog: 'bank-info-dialog',
        filmSection: 'film-section',
        filmWebsiteBtn: 'film-website-btn',
        closingSection: 'closing-section',
        closingWhatsAppBtn: 'closing-whatsapp-btn',
};
